import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import PVMenuLeft from '../Shared/SiteWrapper/Header/PVMenuLeft';
import PVShopBanner from '../Shared/SiteWrapper/Header/PVBanner';
import PVShopBreadcrumbs from './PVShopBreadcrumbs';
import store from '../../redux/store';
import { selectTopLevelCategoryById } from '../../redux/products/category/selectors';

const PVShopWrapper = (props) => {
    const location = useLocation();
    const { heading, children, breadcrumbs, categorypath, webDescription, showViewAllLink, viewAllLink, viewAllDisplayName } = props;

    const [title, setTitle] = useState('');
    const [h1, setH1] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [canonical, setCanonical] = useState('');

    const [bannerUrl, setBannerUrl] = useState('');
    const [leftMenuName, setLeftMenuName] = useState('');
    const isMounted = useRef(null);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    //Keep the logic for SEO metadata in sync in the following places:
    //  MiddleTier/BusinessServiceLayer/WebStore/SEO.cs - First pass of Google indexing (html head)
    //  PV/React/components/Shared/SiteWrapper/PVSiteWrapper.js - Second pass of Google indexing (rendered JavaScript/React helmet)
    //  PV/React/components/PVWebstore/PVShopWrapper.js - Second pass of Google indexing - product category/subcatgory
    useEffect(() => {
        let category = '';
        let categoryAbbreviated = '';
        if (typeof(breadcrumbs[1]) !== 'undefined' && typeof(breadcrumbs[1].linkText) !== 'undefined') {
           category = breadcrumbs[1].linkText;
           categoryAbbreviated = category.replaceAll(' ','').replaceAll('&','');
        }

        let subcategory = '';
        let subcategoryAbbreviated = '';
        if (typeof(breadcrumbs[2]) !== 'undefined' && typeof(breadcrumbs[2].linkText) !== 'undefined') {
           subcategory = breadcrumbs[2].linkText;
           if (category === "New Products") {
               subcategory = '';
           }
           if (category === "Product Specials") {
               subcategory = '';
           }
           subcategoryAbbreviated = subcategory.replaceAll(' ','').replaceAll('&','');
        }

        const shoppingTagline = 'Shop at PerfectVision today for design and performance at a competitive price. Shop online for 1-2 day delivery.';
        let title = '';
        let metaDescription = '';
        let canonical = '';
        let h1 = '';

        if (typeof(subcategory) !== 'undefined' && subcategory.length > 0) {
            title = `${subcategory} | ${category} | PerfectVision`;
            h1 = `${subcategory}`;
            metaDescription = `PerfectVision - ${category} - ${subcategory} - ${shoppingTagline}`;
            canonical = `https://www.perfect-vision.com/Shop/Category/${categoryAbbreviated}/${subcategoryAbbreviated}`;
        } else if (typeof(category) !== 'undefined' && category.length > 0) {
            title = `${category} | PerfectVision`;
            h1 = `${category}`;
            metaDescription = `PerfectVision - ${category} - ${shoppingTagline}`;
            canonical = `https://www.perfect-vision.com/Shop/Category/${categoryAbbreviated}`;
        } else {
            title = "Shop All Products | PerfectVision";
            h1 = 'Shop All Products';
            metaDescription = `${shoppingTagline}`;
        }

        if (category === "New Products") {
            canonical = `https://www.perfect-vision.com/Shop/Category/NewProducts/AllNewProducts`;
        }

        if (category === "Product Specials") {
            canonical = `https://www.perfect-vision.com/Shop/Category/ProductSpecials/AllProductSpecials`;
        }

        //Category and subcategory custom meta descriptions
        switch (window.location.pathname.toLowerCase()) {
            case "/shop/category/antennas/mounts":
                metaDescription = "Order outdoor antenna mounts from PerfectVision. Get 1-2 day delivery from one of our 6 warehouses nationwide.";
                break;
            case "/shop/category/directvresidential/satellite":
                metaDescription = "PerfectVision distributes the DIRECTV satellite equipment and the approved installation supplies for authorized DIRECTV Dealers. Order online from PerfectVision for 1-2 day delivery.";
                break;
            case "/shop/category/cables/rg6coaxial":
                metaDescription = "PerfectVision RG6 cable offers the design and performance at a competitive price. Shop online for 1-2 day delivery.";
                break;
            case "/shop/category/connectors/barrel":
                metaDescription = "We offer waterproof and standard connectors in a familiar barrel connector design. Order online from PerfectVision for 1-2 day delivery.";
                break;
            case "/shop/category/connectors/hardline":
                metaDescription = "PerfectVision offers Hardline pin connectors that are designed to handle the challenges of today's digital cable networks.";
                break;
            //Fiber - 7345 issue 6 - begin
            case "/shop/category/fiberopticsolutions":
                metaDescription = "PerfectVision carries a full array off fiber optic solutions. We have multiple configurations, length, and sizes with the expertise to customize any fiber application. Order today for 1-2 day delivery.";
                break;
            case "/shop/category/fiberopticsolutions/adapters":
                metaDescription = "PerfectVision has full array of optical fiber adapters. Get 1-2 day delivery from one of our 6 warehouses nationwide.";
                break;
            case "/shop/category/fiberopticsolutions/bulkfiber":
                metaDescription = "Reduce costs by buying in bulk. Let PerfectVision wire your network with our vast assortment of bulk fiber optic cable.";
                break;
            case "/shop/category/fiberopticsolutions/cleaners":
                metaDescription = "PerfectVision offers enviromentally friendly fiber cleaners to clean fiber adapters and connectors without harsh chemicals.";
                break;
            case "/shop/category/fiberopticsolutions/connectors":
                metaDescription = "Quick termination onnectors for fiber optic cables  are a fast and easy alternative to polishing. Simplify your project in 1-2 business days.";
                break;
            case "/shop/category/fiberopticsolutions/enclosures":
                metaDescription = "PerfectVision's wall mount fiber enclosures provide versatility and flexibility when it comes to protecting fiber optic cable from the elements.";
                break;
            case "/shop/category/fiberopticsolutions/fiberaccessories":
                metaDescription = "Take your fiber optic network to the next level and browse our selection of optical fiber accessoriess to complete any install.";
                break;
            case "/shop/category/fiberopticsolutions/fiberductsraceways":
                metaDescription = "Let PerfectVision help you protect and route your fiber optic cables. Check out our selection of fiber duct boards today.";
                break;
            case "/shop/category/fiberopticsolutions/fibertrunklines":
                metaDescription = "PerfectVision has a wide selection of fiber optic trunk cables that increase capacity and bandwith. Order today and get fast shipping from one of our six warehouses nationwide.";
                break;
            case "/shop/category/fiberopticsolutions/jumpers":
                metaDescription = "PerfectVision has fiber optic jumpers to support your optical networking. They are available in simplex and duplex styles.";
                break;
            case "/shop/category/fiberopticsolutions/pigtails":
                metaDescription = "PerfectVision offers fiber optic pigtail assemblies that are designed for reliability and performance. Order now and get it witin 1-2 days.";
                break;
            case "/shop/category/fiberopticsolutions/tools":
                metaDescription = "PerfectVision has every optical fiber tool you need to access, clean, connect, and prepare fiber cables. You can order separately or all together in one tool kit.";
                break;
            //Fiber - 7345 issue 6 - end
            //Grounding - 7345 issue 8 - begin
            case "/shop/category/grounding":
                metaDescription = "We provide electrical grounding products for industrial, commercial, and construction businesses. Get 1-2 day shipping from one of our six warehouses across the nation.";
                break;
            case "/shop/category/grounding/bolts":
                metaDescription = "We are your source for grounding split bolts, to keep your network running smoothly and efficiently. Shop our website today.";
                break;
            case "/shop/category/grounding/coaxialprotection":
                metaDescription = "PerfectVision provides compact, heavy-duty gas tube surge protection with our DC Blocks and Surge Protectors. Order yours today.";
                break;
            case "/shop/category/grounding/enclosures":
                metaDescription = "High performance outdoor electrical enclosure boxes provide protection and signal security. Let PerfectVision outfit your home or business today!";
                break;
            case "/shop/category/grounding/ethernetprotection":
                metaDescription = "Let PerfectVision protect your data lines with our surge protector for ethernet! Shop our website today and get 1-2 day shipping!";
                break;
            case "/shop/category/grounding/exothermic":
                metaDescription = "PerfectVision has a wide selection of all the exothermic welding for grounding, bonding and lightning protection.";
                break;
            case "/shop/category/grounding/groundingbars":
                metaDescription = "Some sites have unique requirements and the typical grounding solution doesn't cut it. Let PerfectVision assist you with custom grounding bars!";
                break;
            case "/shop/category/grounding/groundingblocks":
                metaDescription = "Grounding blocks create a central grounding point for an electrical network. PerfectVision has supplies and solutions for every industry.";
                break;
            case "/shop/category/grounding/groundingclamps":
                metaDescription = "Protect your network against lightning strikes and power surges with our ground clamps. Order today and get 1-2 day shipping!";
                break;
            case "/shop/category/grounding/groundingmaterials":
                metaDescription = "Rods, bonding clamps, and clips are just some of the grounding materials that offer lightning protection. Browse our selection of high quality products.";
                break;
            case "/shop/category/grounding/groundingrods":
                metaDescription = "Protect against harsh environmental conditions and power surges with grounding rods. Let PerfectVision outfit your needs today.";
                break;
            case "/shop/category/grounding/groundingstraps":
                metaDescription = "Grounding straps protect individuals and equipment by serving as a safe path to grounding a live current. We offer a variety of sizes to accommodate any project.";
                break;
            case "/shop/category/grounding/groundingwire":
                metaDescription = "A smart, easy way to protect your electrical system is with grounding wires. Order yours today and get 1-2 day shipping.";
                break;
            case "/shop/category/grounding/lugs":
                metaDescription = "Grounding lugs are used to bond wires and surfaces in grounding applications. PerfectVision offers an array of colors and sizes to complete your project.";
                break;
            case "/shop/category/grounding/screws":
                metaDescription = "Create a safe electrical path with self tapping metal screws. Order your set of 100 today from one of our six warehouses nationwide.";
                break;
            case "/shop/category/grounding/tools":
                metaDescription = "Connect wires betweens cables with manual compression or an electrial wire crimping tool. PerfectVision is your reliable source for hassle free connection.";
                break;
            case "/shop/category/grounding/wirepowercable":
                metaDescription = "Whether it's a single wire conductor and a group of wire cable conductors, PerfectVision has a wide selection to fit your needs. Order today and get 1-2 day shipping.";
                break;
            //Grounding - 7345 issue 8 - end
            //CableAccessories - 7570 - begin
            case "/shop/category/cableaccessories/angleadapters":
                metaDescription = "PerfectVision carries a full line of cable accessories including angle adapters. Order online from PerfectVision for 1-2 day delivery.";
                break;
            case "/shop/category/cableaccessories/grommets":
                metaDescription = "Browse our selection of grommets, including hanger inserts, barrel cushions, and clamps to cover holes and protect cables or wires from sharp corners or edges.";
                break;
            case "/shop/category/cableaccessories/conduitseal":
                metaDescription = "Cable gland's can be installed almost anywhere along a cable network for the perfect leak tight conduit seal.";
                break;
            case "/shop/category/cableaccessories/coaxblockshardware":
                metaDescription = "Coax Support Blocks are designed for wireless applications. Reduce material and installation costs by ordering our stackable units today and get 1-2 day delivery.";
                break;
            case "/shop/category/cableaccessories/boots":
                metaDescription = "Boot Assemblies are easy to install and provide a secure and weatherproof fitting for an entry panel. We offer them in four or five inch sizes.";
                break;
            case "/shop/category/cableaccessories/tape":
                metaDescription = "Add an extra layer of insulation on electrical wires with our silicone self-fusing tape and vinyl electrical tape. Order a roll today and get 1-2 day shipping.";
                break;
            case "/shop/category/cableaccessories/entrypanels":
                metaDescription = "Provide a stable point of entry for your coax and fiber cables with our entry point panels. We offer different sizes to fit any project.";
                break;
            case "/shop/category/cableaccessories/waveguideaccessories":
                metaDescription = "Cabling projects that require both bending and twisting could benefit from a Flex Waveguide. Browse our selection of waveguides and accessories.";
                break;
            case "/shop/category/cableaccessories/hoistgrip":
                metaDescription = "Hoisting grips provide an effective way for hoisting coax and elliptical waveguide into position. Check our our hoisting grip kits and order yours today.";
                break;
            case "/shop/category/cableaccessories/roundmemberadapters":
                metaDescription = "Hose clamps and stainless steel banding are a few of the tools we offer for any cable management system. Simplify your project with our round member adapter accessories.";
                break;
            case "/shop/category/cableaccessories/cushions":
                metaDescription = "Seal up unused holes in cushion inserts with cushion plugs. We offer a variety of inserts, that are water and extreme temperature resistant.";
                break;
            case "/shop/category/cableaccessories/standoff":
                metaDescription = "Stand-off adapters connect and mount circuit boards, panels, doors, and gears. We have a large selection of snap-in, universal, and plastic.";
                break;
            case "/shop/category/cableaccessories/weatherproofing":
                metaDescription = "Weather proof your cable system with our SurSeal Compound and heat shrink wrap and provide a flexible airtight and watertight seal. Shop our website today and get 1-2 day shipping.";
                break;
            case "/shop/category/cableaccessories/groundkits":
                metaDescription = "Create secure grounding connections for any size connector with a grounding kit and protect cables from lightning strikes.";
                break;
            case "/shop/category/cableaccessories/hangers":
                metaDescription = "Securely fasten your cables and trunklines with snap-in hangers. Shop our selection of easy to install, stainless steel hangers and get 1-2 day shipping.";
                break;
            //CableAccessories - 7570 - end
            case "/shop/category/passivedascomponents/dcblocks":
                metaDescription = "PerfectVision carries a full line of coaxial protection DC Blocks. Order online from PerfectVision  for 1-2 day delivery.";
                break;
            case "/shop/category/steelcomponents/monopole":
                metaDescription = "Shop Monopole Components and other Monopole Steel products at PerfectVision";
                break;
            case "/shop/category/testmeasurement/rfmonitors":
                metaDescription = "Help detect RF and prevent accidental overexposure. PerfectVision carries RF Monitors and other test equipment.";
                break;
            case "/shop/category/wisp/fiberhandtools":
                metaDescription = "These fiber hand tools are made specifically for fiber applications, Order online from PerfectVision  for 1-2 day delivery.";
                break;
            case "/shop/category/wisp/non-penmounts":
                metaDescription = "PerfectVision non-penetrating mounts eliminate the need to drill holes into the roof surface which pleases property owners and reduces the possibility of roof leaks.";
                break;
        }

        setTitle(title);
        setMetaDescription(metaDescription);
        setCanonical(canonical);
        setH1(h1);

    }, [breadcrumbs]);

    const getParamValueFromURL = (paramName) => {
        if (location.search === '') {
            return '';
        }
        const queryString = location.search.split('?')[1];
        const keyValuePairs = queryString.split('&');
        let paramValue = '';
        keyValuePairs.map((keyValuePair) => {
            const pairParts = keyValuePair.split('=');
            const key = pairParts[0];
            const value = pairParts[1];
            if (key === paramName) {
                paramValue = value;
            }
            return null;
        });
        return paramValue;
    };

    useEffect(() => {
        if (heading && heading.length > 0) {
            const cleanedHeading = heading.replace(/([&()@#$%*=\\/])/g, '').replace(/\s+/g, '-');
            const banner = `/WebSupport/PV_React/WebStore/category-banners/${cleanedHeading}-bnr.jpg`;
            if (isMounted.current) {
                setBannerUrl(banner);
            }
        }
    }, [heading]);

    useEffect(() => {
        const headingCompressed = heading.replace(/ /g, '');
        if (headingCompressed === 'NewProducts') {
            setLeftMenuName('Shop');
        } else if (headingCompressed === 'SearchResults') {
            const pcID = getParamValueFromURL('pcID');
            if (pcID !== '') {
                const state = store.getState();
                const categoryInfo = selectTopLevelCategoryById(state, pcID);
                setLeftMenuName(categoryInfo.categoryName);
            } else {
                setLeftMenuName('Shop');
            }
        } else {
            setLeftMenuName(headingCompressed);
        }
    }, [location]);

    //////Left Menu Controls//////
    //function leftMenuToggle() {
    //    $('.pv-left-nav-wrapper').toggleClass('toggled');
    //}

    //function wrapperClick(evt) {
    //    if (evt.target.closest('#LeftWrapper') || evt.target.id === 'leftMenuToggleBtn') {
    //        return false;
    //    }
    //    $('.pv-left-nav-wrapper').removeClass('toggled');
    //    return true;
    //}

    //document.addEventListener('click', wrapperClick);

    //const ulStyle = { listStyle: 'none', margin: 0, padding: 0, width: 'auto' };
    const contentPlaceholder = { minHeight: '680px' };
    const breadcrumbColumnClass = showViewAllLink ? "col col-xs-8" : "col col-xs-12";

    return (
        <div className="container">
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={metaDescription} data-source="PVShopWrapper.js"/>
                {(canonical.length > 0) ? (
                    <link rel="canonical" href={canonical} data-source="PVShopWrapper.js"/>
                ) : ''}
            </Helmet>
            <div className="pv-main-wrapper webstore">
                {/*  <button
                    type="button"
                    className="pv btn btn-default pv-left-nav-btn hidden-lg"
                    id="leftMenuToggleBtn"
                    onClick={leftMenuToggle}
                >
                    <i className="fa fa-chevron-right" />
                </button> */}
                <PVShopBanner bannerUrl={bannerUrl} heading={h1} renderBanner />
                <div
                    id="LeftWrapper"
                    className="hidden-xs hidden-sm hidden-md col-lg-3 pv-left-nav-wrapper"
                >
                    <div id="LeftNav">
                        <PVMenuLeft leftMenuName={leftMenuName} />
                    </div>
                </div>
                <div className="col-sm-12 col-lg-9 pv-content-wrapper" style={contentPlaceholder}>
                    <div className="row">
                        <div className={breadcrumbColumnClass}>
                            <div className="breadcrumb-wrapper">
                                <PVShopBreadcrumbs breadcrumbs={breadcrumbs} categorypath={categorypath} />
                            </div>
                        </div>
                        {showViewAllLink ?
                            <div className="col col-xs-4">
                                <h3 className="product-view-all">
                                    <Link to={viewAllLink}>
                                        <p>View All</p>
                                        <p>{viewAllDisplayName}</p>
                                    </Link>
                                </h3>
                            </div> : ''}
                    </div>
                    <div className="row">
                        <div className="col-sm-12">                            
                            <h4 className="pv-product-category-web-description">
                                {webDescription}
                            </h4>
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

PVShopWrapper.propTypes = {
    heading: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
    categorypath: PropTypes.string,
    showViewAllLink: PropTypes.bool,
    viewAllLink: PropTypes.string,
    viewAllDisplayName: PropTypes.string
};

PVShopWrapper.defaultProps = {
    heading: '',
    categorypath: '',
};

export default PVShopWrapper;
